import { debounce, pickBy, mapValues } from "lodash-es";
import { injectFields } from "../../../lib/utils/vue";
import { INJECT_SIMPLE_FLOW_EDITOR } from './consts';
import MarkdownForTooltip from "../../../lib/comps/MarkdownForTooltip";
const isSafari = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
const __script_base__ = {
  model: {
    prop: 'value',
    event: 'change'
  },
  components: {
    MarkdownForTooltip
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    displayText: {
      type: String,
      default: ''
    } // 外显的文字，如果配置了，无论是否有值，都显示这个
  },
  inject: {
    simpleFlowEditor: {
      from: INJECT_SIMPLE_FLOW_EDITOR
    }
  },
  data() {
    return {
      popoverVisible: false,
      focused: false,
      filterKey: '',
      contentMinHeight: '0px',
      contentWidth: '0px',
      overlayStyle: Object.freeze({
        pointerEvents: 'none'
      })
    };
  },
  created() {
    this.handleBlur = debounce(() => {
      this.filterKey = this.displayValue;
      this.focused = false;
    }, 200);
    this.$watch('displayValue', () => {
      if (!this.focused) this.filterKey = this.displayValue;
    }, {
      immediate: true
    });
    this.handleFocus = () => {
      this.handleBlur.cancel();
      this.focused = true;
      this.popoverVisible = true;
      this.filterKey = '';
    };
    this.handlePaste = ev => {
      try {
        const obj = JSON.parse(ev.clipboardData.getData('text/plain'));
        this.simpleFlowEditor.ibContext.pasteWithData(obj);
        this.popoverVisible = false;
        this.simpleFlowEditor.ibContext.focus();
        ev.preventDefault();
      } catch (err) {
        console.error('[FlowEditor] Cannot paste via adding input', err);
      }
    };
  },
  beforeDestroy() {
    this.handleBlur.cancel();
  },
  computed: {
    ...injectFields('simpleFlowEditor', ['groupedAtoms', 'atoms']),
    displayValue() {
      if (this.displayText) return this.displayText;
      if (this.atoms[this.value]) {
        return this.atoms[this.value].name;
      }
      return this.value || this.placeholder || '';
    },
    filteredGroupedAtoms() {
      const {
        filterKey,
        value: currentSelectedAtomId,
        groupedAtoms
      } = this;
      const lowerKeys = !filterKey || filterKey === this.displayValue ? null : filterKey.toLowerCase().split(/\s+/g);
      const filterFn = lowerKeys === null ? null : atom => {
        const str1 = `${atom.id} ${atom.name} ${atom.desc}`.toLowerCase();
        return lowerKeys.some(key => key && str1.includes(key));
      };
      return pickBy(mapValues(groupedAtoms,
      // eslint-disable-next-line max-len
      list => list.filter(atom => (atom.visible || atom.id === currentSelectedAtomId) && (!filterFn || filterFn(atom)))), list => list.length > 0);
    }
  },
  updated() {
    const updateOnce = () => {
      let height = '0px';
      let width = '0px';
      const el = this.popoverVisible && this.$refs.dropdown;
      if (el) {
        let lastUl;
        let maxHeight = 0;
        Array.from(el.children).forEach(i => {
          if (!i || !i.offsetParent) return; // ul 可能被隐藏？！
          maxHeight = Math.max(i.offsetHeight, maxHeight);
          lastUl = i;
        });
        if (lastUl) width = `${lastUl.offsetLeft + lastUl.offsetWidth || 0}px`;
        height = `${maxHeight}px`;
      }
      if (height === this.contentMinHeight && width === this.contentWidth) return true;
      this.contentMinHeight = height;
      this.contentWidth = width;

      // Safari 会错位，需要手工刷一下
      if (isSafari) setTimeout(() => {
        var _this$$refs$popover;
        return (_this$$refs$popover = this.$refs.popover) === null || _this$$refs$popover === void 0 ? void 0 : _this$$refs$popover.$forceUpdate();
      }, 100);
    };
    this.$nextTick(updateOnce);
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("a-popover", {
    ref: "popover",
    attrs: {
      trigger: "focus",
      placement: "leftBottom",
      "overlay-style": {
        animationDuration: "0s",
        animation: "none",
        opacity: _vm.popoverVisible ? "1" : "0"
      }
    },
    model: {
      value: _vm.popoverVisible,
      callback: function ($$v) {
        _vm.popoverVisible = $$v;
      },
      expression: "popoverVisible"
    }
  }, [_c("template", {
    slot: "content"
  }, [_c("div", {
    ref: "dropdown",
    staticClass: "ucd-flowAtomSelector-dropdown",
    style: "height: " + _vm.contentMinHeight + "; width: " + _vm.contentWidth,
    attrs: {
      "data-visible": _vm.popoverVisible
    }
  }, _vm._l(_vm.filteredGroupedAtoms, function (curGroupAtoms, group) {
    return _c("ul", {
      key: group,
      ref: "groupAtoms",
      refInFor: true,
      attrs: {
        label: group
      }
    }, [_c("span", {
      staticClass: "ucd-flowAtomSelector-dropdown-title"
    }, [_vm._v(_vm._s(group))]), _vm._v(" "), _vm._l(curGroupAtoms, function (atom) {
      return _c("a-tooltip", {
        key: group + "-" + atom.id,
        attrs: {
          "overlay-style": _vm.overlayStyle
        }
      }, [!!atom.desc ? _c("markdown-for-tooltip", {
        attrs: {
          slot: "title",
          source: atom.desc
        },
        slot: "title"
      }) : _vm._e(), _vm._v(" "), _c("li", {
        class: {
          isSelected: atom.id === _vm.value
        },
        on: {
          click: function ($event) {
            return _vm.$emit("change", atom.id);
          }
        }
      }, [_vm._v("\n            " + _vm._s(atom.name) + "\n          ")])], 1);
    })], 2);
  }), 0)]), _vm._v(" "), _c("a-input", {
    staticClass: "ucd-flowAtomSelector-input",
    attrs: {
      placeholder: _vm.displayValue
    },
    on: {
      focus: _vm.handleFocus,
      blur: _vm.handleBlur,
      paste: _vm.handlePaste
    },
    model: {
      value: _vm.filterKey,
      callback: function ($$v) {
        _vm.filterKey = $$v;
      },
      expression: "filterKey"
    }
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "simpleFlow/SimpleFlowEditor/FlowAtomSelector.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);